export default "__VITE_ASSET__D0t1pFL3__"